import { CART_RECEIVE, CART_SHOW_INFO, ADD_TO_CART_LOADING, CART_LOAD_ERROR } from '../Actions/Cart.action'

export const cart = (
    state = { quantity: 0, orderTotal: 0, showInfo: false, isLoading: false, error: null },
    action
) => {
    switch (action.type) {
        case CART_RECEIVE:
        case ADD_TO_CART_LOADING:
        case CART_LOAD_ERROR:
        case CART_SHOW_INFO:
            return {
                ...state,
                ...action.payload,
            }
        default:
            return state
    }
}
